var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.loaded)?_c('NewAuditReport',{attrs:{"reportData":_vm.data}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }